import { Divider } from '@mui/material'

interface HorizontalDividerProps {
    color?: string
}

export const HorizontalDivider = ({ color }: HorizontalDividerProps) => {
    const finalColor = color || 'var(--mui-palette-secondary-light)'
    return <Divider sx={{ bg: finalColor, my: '16px' }} />
}
